import { compose } from 'redux';
import { connect } from 'react-redux';
import {
    GetListEventOfOrganizerRequested,
    ClearListEventOfOrganizer,
    ApproveRegisterRequested,
    ClearApprovedRegister,
    RejectRegisterRequested,
    ClearRejectedRegister,
    GetDetailOfOrganizerRequested,
    ClearGetDetailOfOrganizer,
    SendInvoiceRequested,
    ClearSendInvoice,
    GetCsvOrganizerRequested,
    GetCsvOrganizerClear,
} from '../../../actions/OrganizerManagement';
import { ResendMailRequested, ClearResendMailData } from '../../../actions/Mail';
import OrganizerManagementSelector from '../../../selectors/OrganizerManagement';
import withAuth from '../../../common/WithAuth';
import ListOrganizer from '../../../pages/Admin/OrganizerManagement/ListOrganizer';
import { GetZonesRequested } from '../../../actions/CommonOptions';

const mapStateToProps = (state) => {
    const organizerResults = OrganizerManagementSelector.createOrganizerManagementResultsSelector()(state);
    const isLoading = state.organizerManagement.get.isFetching
    || state.organizerManagement.approve.isFetching
    || state.organizerManagement.reject.isFetching
    || state.organizerManagement.sendInvoice.isFetching
    || state.commonOptions.Options.isFetching
    || state.organizerManagement.getDetail.isFetching
    || state.commonOptions.zones.isFetching;

    return {
        organizerResults,
        organizers: state.organizerManagement.get.data,
        organizerDetail: state.organizerManagement.getDetail.data,
        approveSuccess: state.organizerManagement.approve.success,
        approveResponse: state.organizerManagement.approve.data,
        approveErrors: state.organizerManagement.approve.errors,
        rejectSuccess: state.organizerManagement.reject.success,
        rejectResponse: state.organizerManagement.reject.data,
        rejectErrors: state.organizerManagement.reject.errors,
        options: state.commonOptions.Options.data,
        eventInfo: state.eventManagement.infoEvent.data,
        invoice: state.organizerManagement.sendInvoice.data,
        invoiceSuccess: state.organizerManagement.sendInvoice.success,
        invoiceErrors: state.organizerManagement.sendInvoice.errors,
        isLoading,
        resendMailSuccess: state.mail.resend.success,
        zones: state.commonOptions.zones.data,
        organizerDownloadData: state.organizerManagement.getCsvOrganizer.data,
        successGetDownloadData: state.organizerManagement.getCsvOrganizer.success,
        dataListLiveStream: state.organizerManagement.getDetail.data?.live_stream,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchOrganizer: (params) => {
        dispatch(GetListEventOfOrganizerRequested(params));
    },
    clearOrganizer: () => {
        dispatch(ClearListEventOfOrganizer());
    },
    fetchDetailOrganizer: (params) => {
        dispatch(GetDetailOfOrganizerRequested(params));
    },
    clearDetailOrganizer: () => {
        dispatch(ClearGetDetailOfOrganizer());
    },
    onApproveOrganizer: (id) => {
        dispatch(ApproveRegisterRequested(id));
    },
    clearApproveOrganizer: () => {
        dispatch(ClearApprovedRegister());
    },
    onRejectOrganizer: (id) => {
        dispatch(RejectRegisterRequested(id));
    },
    clearRejectOrganizer: () => {
        dispatch(ClearRejectedRegister());
    },
    sendInvoice: (id) => {
        dispatch(SendInvoiceRequested(id));
    },
    clearInvoice: () => {
        dispatch(ClearSendInvoice());
    },
    resendMail: (params) => {
        dispatch(ResendMailRequested(params));
    },
    resetResendMailData: () => {
        dispatch(ClearResendMailData());
    },
    fetchEventZones: (shortName) => {
        dispatch(GetZonesRequested(shortName));
    },
    getCsvOrganizer: (params) => dispatch(GetCsvOrganizerRequested(params)),
    getCsvOrganizerClear: () => dispatch(GetCsvOrganizerClear()),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListOrganizer);
